import m from "../../geodata/es2015/uzbekinstanHigh";
window.am4geodata_uzbekinstanHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/uzbekinstanHigh.js
// module id = null
// module chunks = 